import { render, staticRenderFns } from "./product-precent-chart.vue?vue&type=template&id=6ac6b4de&scoped=true&"
import script from "./product-precent-chart.vue?vue&type=script&lang=js&"
export * from "./product-precent-chart.vue?vue&type=script&lang=js&"
import style0 from "./product-precent-chart.vue?vue&type=style&index=0&id=6ac6b4de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac6b4de",
  null
  
)

export default component.exports